/** Strips ANSI escape sequences (color/style codes) from captured console
 * output. The editor console is plain text, so any terminal coloring the
 * Vitest worker applies to inspected values would otherwise render as literal
 * `[32m`/`[39m` artifacts. */
export function stripAnsiCodes(value: string): string {
  // eslint-disable-next-line no-control-regex
  return value.replace(/\x1b\[[0-9;]*m/g, "");
}
